import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MarkantElementsModule } from '@markant/elements-angular';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'markant-platform-calculation-parameters-comparison',
  standalone: true,
  imports: [CommonModule, MarkantElementsModule, TranslocoPipe],
  templateUrl: './calculation-parameters-comparison.component.html',
  styleUrl: './calculation-parameters-comparison.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CalculationParametersComparisonComponent {
  @Input({ required: true }) calculationParameters: string[] = [];
  @Output() itemExpanded: EventEmitter<boolean> = new EventEmitter<boolean>();

  emitItemExpandedChange(isItemExpanded: boolean): void {
    this.itemExpanded.emit(isItemExpanded);
  }
}
